// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"e8eee70d","423":"8ec66b41","583":"a4ac849c","700":"c55e2c0c","865":"1063bf67","902":"c273bbe8","983":"77845f83"}[chunkId] + ".chunk.js";
};